import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { VivaPermissionPopupComponent } from './viva-permission-popup.component';

@NgModule({
  declarations: [
    VivaPermissionPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    VivaPermissionPopupComponent
  ]
})
export class  VivaPermissionPopupModule { }
